export const FIRM_DOCUMENT_MEASUREMENT_DATE_DOCUMENTS_QUERY_KEY = 'firmDocumentMeasurementDateDocuments';
export const FIRM_DOCUMENT_MEASUREMENT_DATE_DOCUMENTS_QUERY_STALE_TIME_MS = 60_000;
